import { ReactNode } from "react"
import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    padding-top: var(--spacing-xl, 24px);
    padding-right: var(--spacing-xl, 24px);
    padding-bottom: var(--spacing-xs, 8px);
    padding-left: var(--spacing-xl, 24px);

    display: flex;
    align-items: center;
  `,
}

export type DialogHeaderProps = {
  className?: string
  children: ReactNode
}

export function DialogHeader(props: DialogHeaderProps) {
  const { children, className } = props
  return (
    <div
      data-dialog-header
      className={cx("HeadlineH5BlackBold", styles.root, className)}
    >
      {children}
    </div>
  )
}
